<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.125 13.6719C3.125 13.0247 3.64967 12.5 4.29688 12.5H6.64062C7.28783 12.5 7.8125 13.0247 7.8125 13.6719V20.7031C7.8125 21.3503 7.28783 21.875 6.64062 21.875H4.29688C3.64967 21.875 3.125 21.3503 3.125 20.7031V13.6719Z"
				:stroke="color"
				stroke-width="1.5625"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M10.1562 8.98437C10.1562 8.33717 10.6809 7.8125 11.3281 7.8125H13.6719C14.3191 7.8125 14.8438 8.33717 14.8438 8.98438V20.7031C14.8438 21.3503 14.3191 21.875 13.6719 21.875H11.3281C10.6809 21.875 10.1562 21.3503 10.1562 20.7031V8.98437Z"
				:stroke="color"
				stroke-width="1.5625"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M17.1875 4.29688C17.1875 3.64967 17.7122 3.125 18.3594 3.125H20.7031C21.3503 3.125 21.875 3.64967 21.875 4.29688V20.7031C21.875 21.3503 21.3503 21.875 20.7031 21.875H18.3594C17.7122 21.875 17.1875 21.3503 17.1875 20.7031V4.29688Z"
				:stroke="color"
				stroke-width="1.5625"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgChart',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
